import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api-service';

@Injectable({
  providedIn: 'root',
})
export class SignupService {
  countries: any = [];
  private readonly countriesUrl = 'lookups/Geo/GetCountries';
  private readonly organizationsUrl = 'Organizations';
  private readonly languagesUrl = 'lookups/Geo/GetCultures';
  private readonly timezonesUrl = 'lookups/Geo/GetTimeZones';
  private readonly businessTiersUrl = 'lookups/Geo/GetBusinessTiers';

  constructor(private apiService: ApiService) { }

  GetCountries() {
    return this.apiService.getFromCore(this.countriesUrl);
  }

  createOrganization(payload: any) {
    return this.apiService.post(this.organizationsUrl, payload);
  }

  getOrganizationDetails(organizationId: string, payload: any) {
    return this.apiService.post(this.organizationsUrl + '/' + organizationId + '/details', payload);
  }

  createUser(organizationId: string, payload: any) {
    return this.apiService.post(this.organizationsUrl + '/' + organizationId + '/users', payload);
  }

  getLanguages() {
    return this.apiService.getFromCore(this.languagesUrl);
  }

  getTimeZones() {
    return this.apiService.getFromCore(this.timezonesUrl);
  }

  getBusinessTiers() {
    return this.apiService.getFromCore(this.businessTiersUrl);
  }
}
